'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

var formatEddQuery = graphqlTag.gql`
  query FormatBlockEdd(
    $eddCombos: [DisplayDateFormatCombo!]!
    $retailerMoniker: String!
    $versionName: String
    $localeLanguage: Language
    $localeCountry: Country
  ) {
    formatEdd(
      eddCombos: $eddCombos
      retailerMoniker: $retailerMoniker
      versionName: $versionName
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
    ) {
      formattedEdds
    }
  }
`;

exports["default"] = formatEddQuery;
